import React from 'react';

//compoenents
import { CpdsCardWrapper, CpdsHorizontalCardContent, CpdsCardHoverContentOverlay } from '../styles/card-component';

//helplers and hooks
import { themeStyleClass } from '../../utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';
import { filterChildrenByDisplayName } from '../helpers';

//types
import { CpdsCardComponentProps } from '../typings';

const CardComponent: React.FC<CpdsCardComponentProps> = (props) => {
  const { domRef, exClasses, styleOverrides, themeTypography, children, variation = 'VERTICAL', ...rest } = props;
  const className = themeStyleClass('cpds-cards', themeTypography, exClasses);

  const hoverContentComponent = filterChildrenByDisplayName(children, 'CardHoverContentWrapper');

  const createHorizontalCardChildLayout = () => {
    if (!checkValue(children)) {
      return null;
    }
    const MediaComponent = filterChildrenByDisplayName(children, 'CardMediaComponent');
    const contentComponent = filterChildrenByDisplayName(children, 'CardContentWrapper');
    const actionComponent = filterChildrenByDisplayName(children, 'CardActionWrapper');
    return (
      <>
        {MediaComponent}
        <CpdsHorizontalCardContent>
          {contentComponent}
          {checkValue(hoverContentComponent) && hoverContentComponent}
          {actionComponent}
        </CpdsHorizontalCardContent>
      </>
    );
  };

  return (
    <CpdsCardWrapper
      styleOverrides={styleOverrides}
      className={className}
      ref={domRef}
      variation={variation}
      isHoverContent={checkValue(hoverContentComponent)}
      {...rest}
    >
      {variation === 'HORIZONTAL' ? createHorizontalCardChildLayout() : children}
      {variation.includes('OVERLAY') && <CpdsCardHoverContentOverlay />}
    </CpdsCardWrapper>
  );
};

export { CardComponent };
